import BaseClass from "../BaseClass.js";

export default class EnumDropdown extends BaseClass {
    static config = {
        regex: {
            style: /^btn(-outline)?-(primary|secondary|success|info|warning|danger)/,
        },
    }

    config = EnumDropdown.config;

    constructor(element) {
        super(element);

        this.$input = this.$element.find('input[type="hidden"]');
        this.$label = this.$element.find('> label.btn');
        this.$labelText = this.$label.find('.enum-dropdown-label');
        this.$divider = this.$element.find('.dropdown-divider');
        this.$clearBtn = this.$element.find('button[data-enum-clear]');
        this.$form = this.$element.parents('form');
        this.style = this.$element.data('style');
        this.label = this.$element.data('label');
        this.autoSubmit = false;

        this.init();
    }

    init() {

        const autoSubmit = this.$element.data('auto-submit');
        if (typeof autoSubmit !== 'undefined' && autoSubmit) {
            this.autoSubmit = true;
        }

        let mySelf = this;
        this.$element.on('click', 'button.dropdown-item, div.dropdown-item', function (event) {
            mySelf.onOptionClick(event);
        });
    }

    onOptionClick(event) {
        const $target = $(event.target);
        const isClear = $target.is('[data-enum-clear]');

        const currentStyleClass = this.getStyleClass(this.$label.get(0));

        let style = null;
        let label = this.label;
        let value = $target.val();

        if ($target.is('div')) {
            value = $target.attr('value');
        }

        if (isClear) {
            value = null;

            this.$divider.hide();
            this.$clearBtn.hide();

            style = this.style;

            this.$labelText.text(this.label);
        } else {
            this.$divider.show();
            this.$clearBtn.show();

            style = $target.data('style');

            const optionLabel = $target.data('label');
            if (typeof optionLabel === 'string') {
                label += ': ' + optionLabel;
            }
        }
        this.$input.val(value);
        if (style !== null) {
            this.$label.removeClass(currentStyleClass);

            let styleClass = 'btn-';
            if (isClear) {
                styleClass += 'outline-';
            }
            styleClass += style;

            this.$label.addClass(styleClass);
        }

        this.$labelText.text(label);

        if (this.autoSubmit) {
            this.$form.submit();
        }
    }

    getStyleClass(element) {
        let style = null;
        for (const currentClass of element.classList) {
            const match = currentClass.match(this.config.regex.style);

            if (match) {
                style = currentClass;
                break;
            }
        }

        return style;
    }
}